import { useEffect, useRef } from 'react';

export default function Reviews() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        if (document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) return;
        const script = document.createElement('script');
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
      },
      { rootMargin: '200px' }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="reviews" className="bg-[#F7F5F1] py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#C8A97E] text-xs font-bold tracking-[0.4em] uppercase mb-4">TESTIMONIALS</p>
          <h2
            className="text-[#2B5741] text-4xl font-bold mb-3"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            What our customers say
          </h2>
          <p className="text-gray-500 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
            Real feedback from our happy clients across Burlington and the surrounding area.
          </p>
        </div>

        <div
          className="elfsight-app-2c5fa253-c065-46ed-b251-e3fed9c581a7"
          data-elfsight-app-lazy
        />
      </div>
    </section>
  );
}
